import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import papa from 'papaparse'
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueGtm from 'vue-gtm'

Vue.use(VueClipboard)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.config.productionTip = false

/**
* Formats a phone number.
* Example: 123-456-7890 => (123) 456-7890
*
* @param {String} phone
* @return {Void}
*/
Vue.filter('phoneFormat', function (phone) {
  return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
})
Vue.filter('toUSD', function (value) {
  return `$${value.toLocaleString(undefined, { currency: 'USD', minimumFractionDigits: 2 })}`
})
Vue.filter('supDecimals', function (value) {
  let parts = value.split('.')
  return parts[0] + '.<sup>' + parts[1] + '</sup>'
})
// https://medium.com/@Taha_Shashtari/an-easy-way-to-detect-clicks-outside-an-element-in-vue-1b51d43ff634
let handleOutsideClick
Vue.directive('closable', {
  inserted (el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        }
      })
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})
// make sure we land at the top of the page after navigation
router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next()
})

// GTM
Vue.use(VueGtm, {
  id: 'GTM-KVXKXF4',
  enabled: true,
  debug: false,
  vueRouter: router,
  ignoredViews: ['loading']
})

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    let _this = this
    papa.parse('/data/seeds.csv', { // in public folder so Millborn can make updates
      download: true,
      header: true,
      complete: function (results) {
        _this.$store.commit('updateAvailableCrops', results.data)
      }
    })
  }
}).$mount('#app')
